import classnames from 'classnames'
import * as React from 'react'
import { PropsWithChildren } from 'react'

import colors from '../../../../../config/colors'

export enum HighlightedBoxColor {
  DarkRed,
  MediumRed,
  LightRed,
  Neutral,
  LightGreen,
  MediumGreen,
  DarkGreen,
}

const LIGHT_BG_COLORS: string[] = [
  colors.red[200],
  colors.red[100],
  colors.red[50],
  colors.gray[50],
  colors.green[50],
  colors.green[100],
  colors.green[200],
]

const DARK_BG_COLORS: string[] = [
  colors.red[500],
  colors.red[600],
  colors.red[700],
  colors.gray[700],
  colors.green[700],
  colors.green[600],
  colors.green[500],
]

const LIGHT_TEXT_COLORS: string[] = [
  colors.red[700],
  colors.red[600],
  colors.red[500],
  colors.gray[600],
  colors.green[500],
  colors.green[600],
  colors.green[700],
]

const DARK_TEXT_COLORS: string[] = [
  colors.white,
  colors.red[200],
  colors.red[300],
  colors.gray[200],
  colors.green[300],
  colors.green[200],
  colors.white,
]

interface HighlightedBoxProps {
  className?: string
  color: HighlightedBoxColor
}

export function HighlightedBox({ children, className, color }: PropsWithChildren<HighlightedBoxProps>) {
  const bgColorsList = FinvizSettings.hasDarkTheme ? DARK_BG_COLORS : LIGHT_BG_COLORS
  const textColorsList = FinvizSettings.hasDarkTheme ? DARK_TEXT_COLORS : LIGHT_TEXT_COLORS

  return (
    <div
      className={classnames(className, 'w-full whitespace-nowrap rounded-[3px] p-0.5 font-medium')}
      style={{ backgroundColor: bgColorsList[color], color: textColorsList[color] }}
    >
      {children}
    </div>
  )
}
